import React from 'react';
import { Link } from 'react-router-dom';
import SupervisorLayout from '../../components/SupervisorLayout';
import { useSupervisorAuth } from '../../context/SupervisorAuthContext';
import './SupervisorCentralPage.css';

// Grille d'icones "Parametres" du superviseur (2026-09-24) — memes items que le
// dropdown "Parametres" du nav (SupervisorLayout.jsx), redondance volontaire
// comme SupervisorCentralPage/SupervisorReportsPage. Gates par
// SupervisorMenuPermission : une tuile non accordee n'apparait pas.
export const parametresItems = [
  { label: 'Banque', icon: '🏦', path: '/supervisor/banque' },
  { label: 'Act/Desactiver Ventes (Manuel)', icon: '🔌', path: '/supervisor/act-desactiver-ventes-manuel' },
];

const SupervisorParametresPage = () => {
  const { supervisor } = useSupervisorAuth();
  const granted = new Set(supervisor?.menu_keys || []);
  const visibleItems = parametresItems.filter((item) => granted.has(item.path));

  return (
    <SupervisorLayout>
      <p className="svc-breadcrumb">
        Ruta : <Link to="/supervisor/dashboard" className="svc-link">Menu</Link>
        {' >> '}
        <Link to="/supervisor/parametres" className="svc-link">Parametres</Link>
      </p>

      {visibleItems.length === 0 ? (
        <p>Aucun parametre accorde — demande a la company de t'en donner l'acces.</p>
      ) : (
        <div className="svc-grid">
          {visibleItems.map((item) => (
            <Link key={item.label} to={item.path} className="svc-item">
              <div className="svc-icon">{item.icon}</div>
              <span className="svc-label">{item.label}</span>
            </Link>
          ))}
        </div>
      )}
    </SupervisorLayout>
  );
};

export default SupervisorParametresPage;
